import { Grid } from '@mui/material';
import { BodyTwoSecondary, HeaderSix, OverlineSecondary, SubtitleOnePrimary } from '../components-atoms/TypographyComponents';
import '../scss/components/_recent-items.scss';
import '../scss/components/_thumbnail.scss';
import { ProductSection } from '../service/serviceService';

export function LearnMore({ products }: { products: ProductSection[] }): JSX.Element {
  return (
    <>
      <section className="recent-items">
        <div className="recent-items__title">
          <HeaderSix>Learn More About Our Products</HeaderSix>
        </div>
        <Grid container item columnSpacing={20 / 8} alignItems="center">
          {products.map(product => (
            <Grid key={product.Title} className="recent-items__content" item lg={4} xl={4} xs={12} md={6} sm={6} >
              <a
                onClick={() => window.open(`/detail/product/${product.Link}`, '_self')}
                className="recent-item recent-item--link"
              >
                <img
                  src={product.Img}
                  className="
                    recent-item__media
                    thumb thumb--large thumb--picture-icon
                  "
                  style={{ padding: 8 }}
                />
                <div className="recent-item__content">
                  <OverlineSecondary>
                    Knowledge Base
                  </OverlineSecondary>
                  <SubtitleOnePrimary className="u-text-truncate-multi">
                    {product.Title}
                  </SubtitleOnePrimary>
                  <BodyTwoSecondary>
                    {product.SubTitle}
                  </BodyTwoSecondary>
                </div>
              </a>
            </Grid>
          ))}
        </Grid>
      </section>
    </>
  );
}
